import React from 'react';
import DocumentCard from 'components/cards/document-card/DocumentCard';
import { Document } from 'core/types';
import {
  formatSimpleDate,
  getDocumentImageSource,
  isFileTypeVideo
} from 'core/util';
import { DATE_FORMAT_MONTH_DATE } from 'core/constants';
import { useVideoThumbnail } from 'core/hooks/useVideoThumbnail';

interface DocumentItemProps {
  document: Document;
  onClick: (document: Document) => void;
}

const DocumentItem: React.FC<DocumentItemProps> = ({ document, onClick }) => {
  const { name, file_url, thumbnail_url, product_data, created } = document;

  // Generate video thumbnail if it's a video file and no thumbnail_url exists
  const { thumbnail: videoThumbnail, loading: thumbnailLoading } =
    useVideoThumbnail(
      !thumbnail_url && isFileTypeVideo(file_url) ? file_url : '',
      1 // Capture frame at 1 second
    );

  const manufacturer = !!product_data?.manufacturer_name
    ? product_data?.manufacturer_name
    : name;

  return (
    <DocumentCard
      title={manufacturer}
      description={`Uploaded ${formatSimpleDate(
        created,
        DATE_FORMAT_MONTH_DATE
      )}`}
      image={getDocumentImageSource(
        file_url,
        thumbnail_url,
        videoThumbnail,
        thumbnailLoading
      )}
      onClick={() => onClick(document)}
    />
  );
};

export default DocumentItem;
